<% var component = new Anvil.models.components.Group(field) %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<% if (!('no_label' in field)) { %>
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<% } %>
	<div class="col">
		<div class="row g-1">
			<% if ('fields' in field) for (let sub_field of field.fields) { %>
				<%- include(sub_field.type, { form, field: Object.assign(sub_field, { inline: true }) }) %>
			<% } %>
		</div>
		<div class="form-group row">
			<div class="col">
				<div id="<%- component.id %>-dummy" class="d-none"></div>
				<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
				<div id="<%- component.id %>-invalid-feedback" class="invalid-feedback"></div>
			</div>
		</div>
	</div>
</div>
